import React from 'react';
import { Button, Checkbox, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useConfirmation } from 'components/Confirmation';
import StepFormToDoList from 'modules/Report/components/StepFormToDoList';
import { IGoalModel } from '@common/models/Goals/Goal';
import MediaTypography from 'components/MediaTypography';
import GoalItemProgress from './Progress';
import { StyledGoalItemInnerWrap,
	StyledGoalItemItemsList,
	StyledGoalItemListItem,
	StyledGoalItemProgressWrap,
	StyledGoalItemWrap } from './styled';

const colorTypes: Record<number, 'error' | 'warning' | 'info' | 'success'> = {
	0: 'warning',
	1: 'info',
	2: 'success',
	3: 'error',
	4: 'warning',
	5: 'info',
};

interface PropsType {
	goalIndex: number;
	isEditing: boolean;
	onClose: () => void;
	onDelete?: (id: number) => void;
	goal: IGoalModel;
}

function GoalItem({ goalIndex, isEditing, onClose, goal, onDelete }: PropsType) {
	const confirm = useConfirmation();

	const handleDelete = async () => {
		confirm({ text: `You want to delete “${goal.title}”` })
			.then(async () => {
				await goal.remove();
				onClose();
			})
			.catch(() => {});
	};

	const getProgress = () => {
		const chekedSteps = goal?.steps?.filter((step) => !!step.is_done).length;

		return goal?.steps?.length ? (chekedSteps / goal.steps.length) * 100 : 0;
	};

	return (
		<StyledGoalItemWrap>
			{/* @ts-ignore */}
			<StyledGoalItemInnerWrap type={colorTypes[goalIndex]}>
				<MediaTypography variant="h3" textColor="secondary">
					{goal.title}
				</MediaTypography>
				{isEditing ? (
					<StepFormToDoList
						goalIndex={goalIndex}
						type={colorTypes[goalIndex]}
						onDelete={onDelete}
					/>
				) : (
					<StyledGoalItemItemsList>
						{goal.steps.map((item, index) => (
							// @ts-ignore
							<StyledGoalItemListItem key={index} type={colorTypes[goalIndex]}>
								<Checkbox disabled checked={!!item.is_done} />
								<Typography component="p">{item.title}</Typography>
							</StyledGoalItemListItem>
						))}
					</StyledGoalItemItemsList>
				)}
				{isEditing && (
					<Button
						variant="contained"
						color="error"
						fullWidth
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
						onClick={handleDelete}
					>
						<DeleteIcon />
						Delete
					</Button>
				)}
				<StyledGoalItemProgressWrap>
					<GoalItemProgress type={colorTypes[goalIndex]} progress={getProgress()} />
				</StyledGoalItemProgressWrap>
			</StyledGoalItemInnerWrap>
		</StyledGoalItemWrap>
	);
}

export default GoalItem;
